// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__pR_VF","emails":"CreateEditClinics_emails__3kkjK","emailTagLabel":"CreateEditClinics_emailTagLabel__2ssQL"};